export default __webpack_public_path__ + "static/media/character_thumbail1.abfccebe.png";